import styled from "styled-components";
import { BrandLogo } from "@stubhub/broadway-web/icons";
import { Col, Container, Row } from "@viagogo/core/ui";

export const TextWrapper = styled.div`
  max-width: 1200px;
  overflow: hidden;
  display: block;
  text-align: center;
  @media ${({ theme: { media } }) => media.phone} {
    margin: ${(props) => props.theme.spacing(4)} auto;
  }
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    margin: ${(props) => props.theme.spacing(8)} auto;
  }
`;

export const StyledTextDiv = styled.div`
  color: ${(props) => props.theme.colors.textPrimary};
  margin: ${(props) => props.theme.spacing(4, 4, 0, 4)};
  padding: ${(props) => props.theme.spacing(0, 4)};
  line-height: ${(props) => props.theme.spacing(8)};

  & a {
    color: ${(props) => props.theme.colors.textLinkPrimary};
  }
`;

export const SectionTitle = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title2)};
  padding: ${(props) => props.theme.spacing(12, 0, 10, 0)};
  text-align: center;
`;

export const AboutUsContainer = styled.div`
  padding: ${(props) => props.theme.spacing(12, 0, 12, 0)};
`;

export const AboutUsContainerWithVideo = styled.div`
  width: 100%;
`;

export const StyledVideo = styled.video`
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    padding: ${(props) => props.theme.spacing(24, 0, 12, 0)};
    text-align: center;
    width: 75%;
  }
  @media ${({ theme: { media } }) => media.phone} {
    padding: ${(props) => props.theme.spacing(6, 0, 0, 0)};
    width: 80%;
  }
  object-fit: contain;
`;

export const VideoWrapper = styled.div`
  text-align: center;
`;

export const DetailsCard = styled.div`
  text-align: center;
  padding: ${(props) => props.theme.spacing(8)};
`;

export const DetailsCardIcon = styled.div`
  height: 120px;
`;

export const DetailsContainer = styled.div`
  height: 560px;
  @media ${({ theme: { media } }) => media.phone} {
    height: 100%;
  }
  @media ${({ theme: { media } }) => media.tablet} {
    height: 100%;
  }
`;

export const StyledDetailCol = styled(Col)`
  position: relative;
`;

export const GuaranteeBackground = styled.div`
  width: 100%;
  height: 452px;
  background-color: #36393a;
  color: ${(props) => props.theme.colors.textInverted};
`;

export const GuaranteeContainer = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    flex-direction: row;
  }
`;

export const GuaranteeSectionTitle = styled.div`
  font-size: 68px;
  line-height: normal;
  text-align: center;
  border-right: 6px solid ${(props) => props.theme.colors.backgroundBrandActive};
  padding-right: ${(props) => props.theme.spacing(16)};
  @media ${({ theme: { media } }) => media.phone} {
    width: 90%;
    font-size: 32px;
    border-bottom: 6px solid ${(props) => props.theme.colors.backgroundBrandActive};
    border-right: none;
    padding: ${(props) => props.theme.spacing(0, 0, 8, 0)};
  }
  @media ${({ theme: { media } }) => media.tablet} {
    max-width: 50%;
    font-size: 60px;
  }
`;

export const GuaranteeSectionTextDiv = styled.div`
  font-size: 24px;
  line-height: normal;
  @media ${({ theme: { media } }) => media.phone} {
    font-size: 18px;
    padding-top: ${(props) => props.theme.spacing(4)};
  }
  @media ${({ theme: { media } }) => media.tablet} {
    font-size: 20px;
  }
`;

export const GuaranteeSectionTextContainer = styled.div`
  padding: ${(props) => props.theme.spacing(0, 4, 0, 4)};
`;

export const CheckMarkIconStyled = styled.div`
  display: inline-block;
  padding: ${(props) => props.theme.spacing(2, 2, 2, 2)};
  svg {
    fill: ${(props) => props.theme.colors.backgroundBrandActive};
  }
`;

export const CheckMarkTextStyled = styled.div`
  display: inline;
`;

export const CheckMarkContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CustomerProofSectionContainer = styled(Container)`
  max-width: 1300px;
  margin-top: ${(props) => props.theme.spacing(6)};
`;

export const CustomerProofSectionRow = styled(Row)`
  margin-bottom: 0;
  flex-direction: column;
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    flex-direction: row;
    margin-bottom: ${(props) => props.theme.spacing(16)};
  }
`;

export const CustomerProofBackgroundCircle = styled.div`
  height: 200px;
  width: 200px;
  display: inline-block;
  justify-content: center;
  align-items: center;
  @media ${({ theme: { media } }) => media.phone} {
    height: 100px;
    width: 100px;
    margin: 0 auto;
  }
  @media ${({ theme: { media } }) => media.tablet} {
    height: 150px;
    width: 150px;
  }
`;

export const CustomerProofSectionCol = styled(Col)`
  flex-basis: 50%;
  max-width: 50%;
  padding-right: ${(props) => props.theme.spacing(12)};
  @media ${({ theme: { media } }) => media.phone} {
    flex-basis: 100%;
    max-width: 100%;
    padding-right: 0;
    margin-bottom: ${(props) => props.theme.spacing(8)};
  }
`;

export const CustomerProofSectionDiv = styled.div`
  display: flex;
  flex-direction: column;
  @media ${({ theme: { media } }) => media.desktop} {
    flex-direction: row;
  }
  @media ${({ theme: { media } }) => media.phone} {
    padding: ${(props) => props.theme.spacing(4, 8)};
    text-align: center;
  }
`;

export const CustomerProofSectionText = styled.div`
  flex: 1;
  padding-top: ${(props) => props.theme.spacing(4)};
  @media ${({ theme: { media } }) => media.desktop} {
    padding-top: 0;
    padding-left: 48px;
  }
`;

export const CustomerProofTitle = styled(Col)`
  color: ${(props) => props.theme.colors.backgroundBrandActive};
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 40px;
  letter-spacing: normal;
  @media ${({ theme: { media } }) => media.phone} {
    font-size: 24px;
    padding-bottom: 20px;
  }
`;

export const StyledBrandLogo = styled(BrandLogo)`
  @media ${({ theme: { media } }) => media.phone} {
    a {
      display: block;
    }
  }
`;

export const StyledArrow = styled.span`
  position: absolute;
  right: -10px;
  top: 15%;
  @media ${({ theme: { media } }) => media.phone} {
    display: none;
  }
`;
